import { GroupInfo, SingleSetting } from "src/components/SettingsEditor";
import { Feature } from "src/states/ApplicationStateFeatures";
import { WindowId } from "src/WindowManager/WindowState";

const settingsGroups: GroupInfo = [
  {
    key: "bnbo",
    da: "BNBO",
    en: "BNBO"
  },
  {
    key: "status",
    da: "Status",
    en: "Status"
  }
]

const settings: SingleSetting[] = [
  {
    access: Feature.BNBOTool,
    group: "bnbo",
    key: "bnbo.kommuneNavn",
    default: "",
    type: "String",
    da: "Kommunenavn",
    en: "Municipality name",
  },
  {
    access: Feature.BNBOTool,
    group: "bnbo",
    key: "bnbo.kommuneErstatningsProcent",
    default: 60,
    min: 0,
    max: 100,
    type: "Integer",
    da: "Erstatningsprocent",
    en: "Erstatnings Procent",
    suffix: "%",
  },
  {
    access: Feature.BNBOTool,
    group: "bnbo",
    key: "bnbo.erstatningsFaktorer.omdriftsAreal",
    type: "Float",
    min: 0,
    default: 1,
    max: 1,
    da: "Faktor omdriftsareal",
    en: "Faktor Omdrifts Areal",
  },
  {
    access: Feature.BNBOTool,
    group: "bnbo",
    key: "bnbo.erstatningsFaktorer.servitutAreal",
    type: "Float",
    min: 0,
    default: 0.5,
    max: 1,
    da: "Faktor servitutareal (ikke omdrift)",
    en: "Faktor Servitut Areal",
  },
  {
    access: Feature.BNBOTool,
    group: "bnbo",
    key: "bnbo.erstatningsFaktorer.ulempeAreal",
    type: "Float",
    min: 0,
    default: 0.5,
    max: 1,
    da: "Faktor ulempeareal",
    en: "Faktor Ulempe Areal",
  },
  {
    access: Feature.BNBOTool,
    group: "bnbo",
    key: "bnbo.erstatningsFaktorer.paragraf3Areal",
    type: "Float",
    min: 0,
    default: 0,
    max: 1,
    da: "Faktor §3-areal",
    en: "Faktor Paragraf-3 Areal",
  },
  {
    access: Feature.BNBOTool,
    group: "bnbo",
    key: "bnbo.erstatningsFaktorer.fredskovsAreal",
    type: "Float",
    min: 0,
    default: 0.5,
    max: 1,
    da: "Faktor fredskovsareal",
    en: "Faktor Fredskovsareal",
  },
  {
    access: Feature.BNBOTool,
    group: "bnbo",
    key: "bnbo.erstatningsFaktorer.fradragsAreal",
    type: "Float",
    min: 0,
    default: 0.0,
    max: 1,
    da: "Faktor fradragsareal",
    en: "Faktor Fradrags Areal",
  },
  {
    access: Feature.BNBOTool,
    group: "bnbo",
    key: "bnbo.erstatningsFaktorer.vejareal",
    type: "Float",
    min: 0,
    default: 0.0,
    max: 1,
    da: "Faktor vejareal",
    en: "Faktor vejareal",
  },
  {
    access: Feature.BNBOTool,
    group: "bnbo",
    key: "bnbo.landbrugsArealPris.min",
    default: 22,
    min: 0,
    max: 100,
    type: "Integer",
    da: "Landbrugsareal Pris (Min)",
    en: "Landbrugsareal Pris (Min)",
    suffix: "dkk",
  },
  {
    access: Feature.BNBOTool,
    group: "bnbo",
    key: "bnbo.landbrugsArealPris.max",
    default: 24,
    min: 0,
    max: 100,
    type: "Integer",
    da: "Landbrugsareal Pris (Maks)",
    en: "Landbrugsareal Pris (Max)",
    suffix: "dkk",
  },
  {
    access: Feature.BNBOTool,
    group: "status",
    key: "bnbo.statusOptions",
    default: [
      { "val": "Ny", "color": "#f5c41b" },
      { "val": "Under udarbejdelse", "color": "#0f9ed5" },
      { "val": "Klar", "color": "#ffa62b" },
      { "val": "Sendt til høring", "color": "#994010" },
      { "val": "Høring udløbet", "color": "#095f80" },
      { "val": "Tinglyst", "color": "#2f641c" },
      { "val": "Afvist", "color": "#bb3428" },
      { "val": "Accepteret", "color": "#2cbaf0" },
      { "val": "Godkendt", "color": "#68cc45", "afsluttet": true }
    ],
    type: "ExternalEditor",
    windowId: WindowId.BNBOStatusEditor,
    da: "Statusmuligheder",
    en: "Status Options",
  }
]

export const BNBOConst = {
  settingsFixedPriorities: 70,
  settingsGroups: settingsGroups,
  settings: settings
}